import { motion } from "framer-motion";
import { assetUrl } from "@/lib/api";

const EASE = [0.19, 1, 0.22, 1];

export function HeroFull({ media }) {
  const item = Array.isArray(media) && media.length ? media[0] : null;

  return (
    <section data-testid="hero-full" className="relative w-full h-[56vh] min-h-[420px] md:h-[72vh] overflow-hidden bg-[#2A331C]">
      <div className="absolute inset-0" data-testid="hero-full-media">
        {item ? (
          item.type === "video" ? (
            <video className="w-full h-full object-cover" autoPlay muted loop playsInline preload="auto">
              {item.webm && <source src={assetUrl(item.webm)} type="video/webm" />}
              <source src={assetUrl(item.mp4 || item.url)} type="video/mp4" />
            </video>
          ) : (
            <img src={assetUrl(item.url)} alt="A DonoDidio celebration" className="w-full h-full object-cover" />
          )
        ) : (
          <div className="w-full h-full hero-full-placeholder" data-testid="hero-full-placeholder" />
        )}
        <div className="absolute inset-0 bg-black/45" />
      </div>

      <div className="relative z-10 h-full flex items-center justify-center px-6">
        <motion.img
          src="/logo.png" alt="DonoDidio Event Management"
          className="hero-logo-gold w-64 sm:w-80 md:w-[26rem] lg:w-[30rem] h-auto"
          initial={{ opacity: 0, y: 28 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.3, ease: EASE }}
        />
      </div>
    </section>
  );
}
